exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer[data-v-f9ffc72a]{display:flex;justify-content:space-between;flex-wrap:wrap;padding:50px 25px;color:#fff;background:linear-gradient(to right bottom,#363636,#202020)}img[data-v-f9ffc72a]{width:225px;height:75px}p[data-v-f9ffc72a]{line-height:.5;font-size:14px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f9ffc72a","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Footer.vue
// module id = 620
// module chunks = 0